import { Controller } from "@hotwired/stimulus"
import { SKIN_KEY_PREFIX, SKIN_NONE } from "./budget_skins_controller"

// Edit budget's card background grid. Saves on tap, like the order grid
// saves on drop, and dispatches "picked" so Save comes alive. The plain
// surface is no key at all, except on a budget with a default background
// (Needs / Wants), where it is stored as "none" so the default stays off.
export default class extends Controller {
  static targets = ["swatch"]
  static values = { id: String, default: String }

  connect() {
    const stored = this._read()
    this._mark(stored === SKIN_NONE ? "" : (stored || this.defaultValue))
  }

  select(event) {
    const skin = event.currentTarget.dataset.skin || ""
    try {
      if (skin) localStorage.setItem(this._key, skin)
      else if (this.defaultValue) localStorage.setItem(this._key, SKIN_NONE)
      else localStorage.removeItem(this._key)
    } catch (error) {
      console.warn("Budget skin not saved:", error)
      return
    }
    this._mark(skin)
    this.dispatch("picked")
  }

  get _key() {
    return SKIN_KEY_PREFIX + this.idValue
  }

  _read() {
    try { return localStorage.getItem(this._key) } catch { return null }
  }

  // Same selected state as the icon grid (emoji_picker_controller).
  _mark(skin) {
    this.swatchTargets.forEach(el => {
      const on = (el.dataset.skin || "") === skin
      el.classList.toggle("ring-2", on)
      el.classList.toggle("ring-blue-500", on)
      el.classList.toggle("scale-110", on)
      el.setAttribute("aria-pressed", on)
    })
  }
}
